import axios from 'axios';
import { Message } from "element-ui";
import {getToken, removeAuth, removeToken} from './auth';
import jsonBig from 'json-bigint'


const request = axios.create({
    baseURL: "http://36.134.183.225:9898",
    timeout: 20000,
     // transformResponse 允许自定义原始的响应数据（字符串）
  transformResponse: [function (data) {
    try {
      // 如果转换成功则返回转换的数据结果
      return jsonBig.parse(data)
    } catch (err) {
      // 如果转换失败，则包装为统一数据格式并返回
      return {
        data
      }
    }
  }]
})
console.log(request);


request.interceptors.request.use(
    config => {
        const token = getToken()
        if (token) {
            config.headers['Authorization'] = token
        }
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

request.interceptors.response.use(
    response => {

        let code = response.data.code
        if (code && code !== '0000') {
            Message({
                message:response.data.message,
                type:'error'
            })
        }
        return response.data
    },
    error => {
        switch (error.response.status) {
            case 401:
                removeAuth()
                removeToken()
                location.reload()
                break
            case 400:
                Message({
                    message:error.response.data.message,
                    type:'error'
                })
                break
            case 403:
                console.log(error);
                console.log("11111");

                Message({
                    message:error.response.data.message,
                    type:'error'
                })
                break
            case 404:
                Message({
                    message:response.data.message,
                    type:'error'
                })
                break
            case 500:
                Message({
                    message:response.data.message,
                    type:'error'
                })
                break
            case 503:
                Message({
                    message:response.data.message,
                    type:'error'
                })
                break
            default:
                uni.showToast({title:error.response.data.error})
        }
        return error.response.data
    }
)

export default function (config) {
    return request(config)
}